module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e322924"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter 2 ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768_ps_0014_001",
      "id": "d14e1163",
      "src": "images/9781580629768_ps_0014_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d6e323624"
    }
  }, [_c('b', [_vm._v("When Self-Esteem Is Unhealthy ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e324424"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he beast of unhealthy self-esteem knows no prejudice; it does not discriminate based on race, age, sex, religion, or any other social or economic category. It does not work on a time clock and approach when it is convenient. It does not tap on your door and ask your permission to enter.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d6e328725"
    }
  }, [_c('b', [_vm._v("Recognizing Unhealthy Self-Esteem")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e329225"
    }
  }, [_vm._v("The beast of unhealthy self-esteem wanders into your life at the time and place of its choosing. It sometimes masks itself as depression, fear, anxiety, or feelings of utter worthlessness. The beast knows no boundaries and has a mind all its own. It is relentless unless you learn how to recognize its approach, distinguish its footsteps on your porch, and deny its entrance into your life. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e331725"
    }
  }, [_vm._v("There are those who think that people who suffer with self-esteem issues are introverts who never leave home; individuals who are submissive and oppressed; or people who fail at family, career, and friendships; and people who are always involved in self-destructive, self-sabotaging activities. This simply is not true. Granted, a lack of self-esteem certainly causes many people to be introverted or have poor relationships, but generally speaking, the downtrodden are not the only people who have self-esteem issues. People with self-esteem issues come from every walk of life; they are lawyers, auto mechanics, hospitality professionals, teachers, swimmers, construction workers, and investment brokers.")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768_ps_0025_001",
      "id": "d14e1176",
      "src": "images/9781580629768_ps_0025_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e335725"
    }
  }, [_c('b', [_vm._v("What is self-sabotage?")]), _c('br'), _vm._v("Self-sabotage is consciously or unconsciously doing things to obstruct your success. This includes lying, cheating, closing off your emotions, attacking others, refusing to participate in activities, and procrastinating.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e338125"
    }
  }, [_c('b', [_vm._v("Phillip and the Good Life ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e338625"
    }
  }, [_vm._v("A compelling example of this is a young man named Phillip, who worked as an accountant for a major firm. He drove a new Viper, owned his own home, and seemed to be as happy as anyone could be. He often spoke of going out with friends and taking vacations. The good life was his.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e340525"
    }
  }, [_vm._v("But Phillip revealed to a friend that he was totally miserable. His friend was completely shocked. He had gone into accounting because his parents pressured him by refusing to pay for his college education unless he majored in a business field that “offered lucrative employment.” The car and home were purchases aimed at making him happier in a job he hated. When he assessed his friendships honestly, he admitted that he had only one real friend; the rest were merely acquaintances. He confided, “I don’t contribute anything to anybody or any purpose. I feel useless and I’m miserable.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e344226"
    }
  }, [_vm._v("In order for Phillip to be happy, he had to change his life. He had to make adjustments so that his own personality could begin to blossom. On his own dime, and on his own terms, he returned to school to study what he loved most, drawing and painting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e346026"
    }
  }, [_vm._v("Today, Phillip owns his own art supply store. His accounting background comes in quite handy, but he is using his skill as an accountant to augment his passion, his “calling” in life. He makes time to draw and paint now, and he is surrounded by artists on a daily basis.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e347626"
    }
  }, [_c('b', [_vm._v("The Moral of Phillip’s Tale ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e348126"
    }
  }, [_vm._v("Much of Phillip’s self-esteem was tied to his work. Research suggests that this is usually true for men, while women tend to tie their self-esteem to family and home. You may be thinking, "), _c('i', [_vm._v("Well good for Phillip, but I ")]), _c('i', [_vm._v("can’t just up and quit my job; I have to make a living somehow. ")]), _vm._v("You might even be thinking, "), _c('i', [_vm._v("My career is not the problem; I love my work. I’m just not happy with X or Y or Z. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768_ps_0086_001",
      "id": "d14e1206",
      "src": "images/9781580629768_ps_0086_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e351526"
    }
  }, [_vm._v("Research shows that people spend less than thirty hours over their entire lifetime thinking about and researching their career choices. If you begin work at twenty years of age, work forty hours per week, and retire at sixty-five, you will have worked 93,600 hours in a job that may not have been your calling. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e353726"
    }
  }, [_vm._v("The moral of the story about Phillip is varied. Phillip was quite successful in the eyes of many people, but inside, he was in agony. He was unhappy and suffering from diminished self-esteem for several reasons, the most essential one being that he was working in a job that did not match his purpose in life. This is a real-life example of someone who did something to change his life and improve his self-esteem. There is no positive affirmation that could have changed his life. He could have repeated, “I am successful,” “I am happy,” “I love my job,” 10,000 times, and at the end of the day, he would still have known the truth. He took action and found his fervor, his purpose. You can, too.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d6e357927"
    }
  }, [_c('b', [_vm._v("What Self-Esteem Isn’t ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e358427"
    }
  }, [_vm._v("Sometimes it is easier to understand what self-esteem really is by looking at what it is not. You may recognize many of the following traits from experiencing them yourself or by witnessing them in other people.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e359727"
    }
  }, [_c('b', [_vm._v("There Is No Bandwagon ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e360227"
    }
  }, [_vm._v("First, self-esteem is not a group activity. There is no “we” in self-esteem. You never hear people talking about “our” self-esteem. In this voyage, you are on your own. Yes, you can seek the advice of loved ones, you can share your dreams and struggles, and you can talk about your advances and setbacks; I encourage that. But ultimately, there is only you. It is essential to your journey that you understand this concept. No one can give you self-esteem.")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768-27",
      "id": "d14e1222",
      "src": "images/9781580629768-27.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e363327"
    }
  }, [_vm._v("“I want to know if you can be alone with yourself, and if you truly like the company you keep in the empty moments.”"), _c('br'), _vm._v(" — Oriah Mountain Dreamer, Native American Elder ")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e365127"
    }
  }, [_c('b', [_vm._v("Leave the Magic to Merlin ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e365627"
    }
  }, [_vm._v("Self-esteem is not an illusion. It is abstract and intangible at times, but it is not an illusion. Healthy self-esteem is possible and real. Many people give up on self-esteem because they have never tried to improve it, used incorrect techniques and advice, and/or allowed themselves to believe that it is a myth postulated by “mystical healers.” Self-esteem is real, and your journey will be real, also.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e368228"
    }
  }, [_c('b', [_vm._v("I’m Too Sexy for My Shirt ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e368728"
    }
  }, [_vm._v("Self-esteem is not arrogance. Arrogance is an overabundance of false pride that is used as a defense when a person feels his or her actions or character are being attacked. Arrogance aligns itself with egocentrism, a belief that your worth and importance is greater than John Doe’s worth and importance. People with healthy self-esteem find joy in recognizing others’ worth as well. Self-esteem is about finding one’s inner beauties, strengths, and gifts and using them to the fullest advantage. It is not about bragging and making yourself more than you are. As you well know, few things turn people off more than the unabated arrogance of a person.")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768-27",
      "id": "d14e1237",
      "src": "images/9781580629768-27.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e372128"
    }
  }, [_vm._v("“Tell me what you brag about and I’ll tell you what you lack.”"), _c('br'), _vm._v(" — Spanish proverb ")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e373428"
    }
  }, [_c('b', [_vm._v("Could You Stamp This Please?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e374128"
    }
  }, [_vm._v("Self-esteem is not validation. There are those who believe that if they can get a few people to love them (or to like them), they will be validated as a person of worth. Self-esteem is about only one type of validation — self-validation. It means that you have come to terms with your worth and merit and that is the only stamp of approval that you need to survive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e376228"
    }
  }, [_vm._v("Some people seek validation through detrimental avenues. They believe that self-esteem will come if they can get validation through whom they know (“Guess who "), _c('i', [_vm._v("I ")]), _vm._v("went out to dinner with last night?”), what they have (“You’ll just have to come with us on our new boat . . . we bought a larger one!”), how they look (“Brandon told me I was beautiful”), where they’ve been (“It’s nice, but not nearly as nice as when we were in Florence!”), or what they do (“I’m the executive vice president to the CEO of the owner”). There is absolutely nothing wrong with being proud of what you have and where you’ve been, but it will not validate your existence.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e380128"
    }
  }, [_c('b', [_vm._v("Wallowing in the Mire ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e380628"
    }
  }, [_vm._v("Self-esteem is not about “if only.” Yes, you may have to revisit the past and make reparations for pain and hurt, but the road to healthy self-esteem does not involve a vocabulary filled with “if only . . .” The past is done. You can never change it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e382729"
    }
  }, [_vm._v("The most you can hope for from the past are lessons learned and possibly forgiveness. Nothing can be gained from “if only-ing” yourself to tears. You know the drill: If only I had worked harder. If only I had been more self-sufficient. If only I had foreseen. If only I had loved him or her more. If only I had not been afraid. If only I had been stronger, quicker, braver, happier, healthier, friendlier, sexier, thinner, prettier, less selfish, richer, smarter, more outgoing, sportier, more powerful . . . yaddah, yaddah, yaddah. Aren’t you tired? “If only” is one of the worst enemies of healthy self-esteem. Move on!")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d6e386929"
    }
  }, [_c('b', [_vm._v("Characteristics of Unhealthy Self-Esteem")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e387429"
    }
  }, [_vm._v("Debilitating. That is a powerful and scary word, but it is a fact of life for scores of people who suffer from low, unhealthy self-esteem. It is amazing how many people still joke about self-esteem as if it were a word made up to explain away a hangnail. Unhealthy self-esteem has ramifications that reach into your career, your relationships, your behaviors, and your psychological well-being. ")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768_ps_0174_001",
      "id": "d14e1265",
      "src": "images/9781580629768_ps_0174_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e390229"
    }
  }, [_vm._v("Your personal attitude is as visible as the clothes you wear. People see the attitude that you wear and they treat you accordingly. People with positive attitudes and an upbeat way of thinking are greeted with positive feedback. People who have negative viewpoints and constantly act downtrodden are treated as such. Your attitude is a self-fulfilling prophecy. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e392929"
    }
  }, [_vm._v("Self-esteem is not a panacea for world peace and total bliss, but it definitely has its benefits. This list includes some of the negative behaviors and attitudes associated with unhealthy, poor self-esteem. You decide if these attitudes or behavior have ever crippled you in some way or if you recognize these characteristics in yourself or other people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e395730"
    }
  }, [_vm._v("Generally speaking, people with self-esteem issues may have a tendency to:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e396730"
    }
  }, [_vm._v("• Act immature and have poor interpersonal skills.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e397230"
    }
  }, [_vm._v("• Participate in self-destructive behaviors.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e397730"
    }
  }, [_vm._v("• Become angry and lose their tempers quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e398330"
    }
  }, [_vm._v("• Sacrifice their identity for the sake of “fitting in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e398830"
    }
  }, [_vm._v("• Dodge reality and unpleasant situations.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e399330"
    }
  }, [_vm._v("• Enjoy the demise or humiliation of others.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e399930"
    }
  }, [_vm._v("• Criticize themselves and others frequently.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e400430"
    }
  }, [_vm._v("• Act superior and brag incessantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e400930"
    }
  }, [_vm._v("• Overreact when criticized in any manner.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e401530"
    }
  }, [_vm._v("• Engage in self-sabotage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e402230"
    }
  }, [_vm._v("This list may be just the entrance to the mine. Deeper and darker characteristics appear in countless people who leave their esteem unattended.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d6e403530"
    }
  }, [_c('b', [_vm._v("Looking for Love in the Wrong Faces ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e404030"
    }
  }, [_vm._v("Another unhealthy characteristic of people with low self-esteem is looking for “love” or affection or even sex from anyone because you do not feel you deserve real love or affection. "), _c('i', [_vm._v("I’ll take what I can get, ")]), _vm._v("you convince yourself. "), _c('i', [_vm._v("He’s better than nothing, ")]), _vm._v("you say on those lonely nights. These feelings come from years and years of convincing yourself that you are not really worthy of true, authentic love because there is something wrong with you. Stop for a moment and think how totally debilitating, thoroughly devastating, and downright tragic that thought is: “I am not worthy of love. I am not worthy of love.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e408430"
    }
  }, [_vm._v("So in that unworthy state, you search for anyone who shows you the least bit of attention. You take “love” in any form you can get it. You give of yourself emotionally, financially, and yes, sexually just so you can have another person hold you for a few moments. Does any of this sound familiar? If it does, then you know how demoralizing these actions are to you and how damaging they are to your self-esteem. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e411131"
    }
  }, [_vm._v("The psychologist Abraham Maslow detailed the basic need for every human being to feel love. It is innate. It is a part of our genetic makeup. It is as necessary as air and water, and our need to feel love can sometimes be overwhelming. The relationship of this need to your self-esteem is this — if you feel badly about yourself and feel that you are not truly worthy of something so wonderful, you will either deny yourself this treasure, or you will take it from the first person that offers it, even if it is false and not genuine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e414731"
    }
  }, [_vm._v("When you wake up in the morning with one more “bad love experience,” this only deepens the feeling and belief that you are not worthy. It is only when you can begin to understand that you do deserve honest love, and that you don’t have to take the first thing that comes along (because you believe it may never come again), that you begin to know your worth. Unhealthy self-esteem inhibits us from seeing that authentic, legitimate love is out there for us. It forbids us from being able to welcome, understand, or appreciate the real thing when it comes along.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d6e417631"
    }
  }, [_c('b', [_vm._v("The Effects of Unhealthy Self-Esteem ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e418131"
    }
  }, [_vm._v("Unhealthy self-esteem can worm its way into every facet of your life. Sometimes, many of your problems may be tied to unhealthy self-esteem and you don’t even know it. People with unhealthy self-esteem tend to be pessimistic and then push that pessimistic view on the world. If you are a pessimistic person, this affects the way you see yourself moving and working in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e420631"
    }
  }, [_vm._v("People with unhealthy self-esteem also often display anger toward others inappropriately. If you are filled with rage and anger, you have a hard time controlling it and a harder time still of knowing where to focus that anger. Tied to this anger, people with unhealthy self-esteem also become aggressive for no apparent reason. The smallest remarks or criticism can send them into a tirade. They begin to blame others for their lot in life and refuse to accept responsibility for their own actions and the consequences. They tend to have very little compassion for their own lives, and thus, they have very little compassion for others. If they have nothing to live for, they can’t see that other people do.")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768-27",
      "id": "d14e1320",
      "src": "images/9781580629768-27.jpg"
    }
  })]), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d6e424632"
    }
  }, [_vm._v("“The point of the journey is not just healing. It’s also recovering the truest, most spontaneous, joyful, and creative core of ourselves.”"), _c('br'), _vm._v(" — Gloria Steinem ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e426432"
    }
  }, [_vm._v("Ironically, it has even been suggested that people with unhealthy self-esteem tend to be more promiscuous and participate in unhealthy sexual behavior at a greater rate than those with healthy self-esteem.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e427932"
    }
  }, [_c('b', [_vm._v("More Bad News ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e428532"
    }
  }, [_vm._v("Following are further examples of how unhealthy self-esteem affects people from every walk of life. People with low self-esteem tend to:")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e429532"
    }
  }, [_vm._v("• Pressure people and become overbearing.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e430032"
    }
  }, [_vm._v("• Be devastated by simple mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e430532"
    }
  }, [_vm._v("• Have few resources.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e431132"
    }
  }, [_vm._v("• Provoke domestic and social violence.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e431632"
    }
  }, [_vm._v("• Concentrate on their failures, weaknesses, and setbacks.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d6e432132"
    }
  }, [_vm._v("• Put themselves down either in a joking fashion or seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d6e432832"
    }
  }, [_c('b', [_vm._v("Give Me All You’ve Got ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e433332"
    }
  }, [_vm._v("It is interesting to note that people with unhealthy self-esteem are prone to engage in obsessive activities such as overeating, overdrinking, or binge drinking. They tend to develop addictions to legal and illegal mood-altering substances at a greater rate than people with healthy self-esteem. Perhaps this phenomenon has something to do with searching for peace outside the body. When you feel that you have no control over what is happening in your mind and soul, you try other outlets to ease the pain and erase the hurt. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e436732"
    }
  }, [_vm._v("Does unhealthy self-esteem cause drug addiction and alcoholism? There is no proof of this and the answer is probably no, but when you are in pain, you search for what brings relief. You search for what helps you forget. You search for what helps you escape. Once again, the beast of unhealthy self-esteem has ramifications that reach further than most people care to admit. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e439533"
    }
  }, [_vm._v("As you can see, poor self-esteem left unattended can have devastating and far-reaching effects on the person who suffers and the society in which they live. Can possessing a healthy self-esteem erase all of the bad things that happen in your life and all of the negative aspects of your personality? No. But left unattended, unhealthy, low self-esteem can take over your life as quickly and completely as kudzu in a vegetable garden. "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768-13",
      "id": "d14e1354",
      "src": "images/9781580629768-13.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e36d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c11_r1.vue
// module id = 90
// module chunks = 0